
import * as MUTATION from '../mutationTypes'
import ajax from '../../http/ajax'
const state = {
    data_list: {},
    floor_list: {},
}

const mutations = {
    [MUTATION.GET_MERGESPREAD_REQUEST] (state, res) {
    },
    [MUTATION.GET_MERGESPREAD_SUCCESS] (state, res) {
        state.data_list = res
    },
    [MUTATION.GET_MERGESPREAD_FLOOR_LIST_REQUEST] (state, res) {
    },
    [MUTATION.GET_MERGESPREAD_FLOOR_LIST_SUCCESS] (state, res) {
        state.floor_list = res
    },
}

export const actions = {
    async getMergeSpreadDetail ({ commit }, params) {
        commit(MUTATION.GET_MERGESPREAD_REQUEST)
        const res = await ajax.get('aggregationTopicDetail', params)
        commit(MUTATION.GET_MERGESPREAD_SUCCESS, res)
    },
    async getMergeSpreadFloorList ({ commit }, params) {
        commit(MUTATION.GET_MERGESPREAD_FLOOR_LIST_REQUEST)
        const res = await ajax.get('aggregationFloorListGet', params)
        commit(MUTATION.GET_MERGESPREAD_FLOOR_LIST_SUCCESS, res)
    },
}

export default {
    state,
    mutations,
}
